export default "__VITE_ASSET__CnYGJZEK__"